export const SET_LOADING = 'SET_LOADING';

export const SAVE_LIST = 'SAVE_LIST';

export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';